import { render, staticRenderFns } from "./CV.vue?vue&type=template&id=52728a24&"
import script from "./CV.vue?vue&type=script&lang=ts&"
export * from "./CV.vue?vue&type=script&lang=ts&"
import style0 from "./CV.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports